/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */
import {Reducer} from 'redux';

import {IChannel} from 'interfaces/channelProps';
import {
  CHANNELS_FETCHING,
  CHANNELS_DONE_FETCHING,
  CHANNELS_ERROR_FETCHING,
  CHANNEL_REMOVE,
  ChannelsActions
} from 'store/action/channels';
import {IPortalError} from 'utility/error-handler';

export interface IChannelsState {
  channelList: IChannel[];
  isFetching: boolean;
  error: null | IPortalError;
}

const initialChannelsState: IChannelsState = {
  channelList: [],
  isFetching: false,
  error: null
};
const channelsReducer: Reducer<Readonly<IChannelsState>, ChannelsActions> = (
  state: IChannelsState = initialChannelsState,
  action: ChannelsActions
) => {
  switch (action.type) {
    case CHANNELS_FETCHING:
      return {
        ...state,
        error: null,
        isFetching: true
      };
    case CHANNELS_DONE_FETCHING:
      return {
        ...state,
        channelList: action.channelList,
        error: null,
        isFetching: false
      };
    case CHANNELS_ERROR_FETCHING:
      return {
        ...state,
        error: action.error,
        isFetching: false
      };
    case CHANNEL_REMOVE:
      return {
        ...state,
        channelList: state.channelList.filter(channel => channel.channelId !== action.channelId)
      };
    default:
      return state;
  }
};

export default channelsReducer;